var map = {
	"./ASC_SORT.svg": "f2b2",
	"./BUY.svg": "2cfb",
	"./CALENDER.svg": "0c7b",
	"./CHECK.svg": "cacd",
	"./CHECKBOX.svg": "c885",
	"./CHEVRON_BOTTOM.svg": "c723",
	"./CHEVRON_LEFT.svg": "84e2",
	"./CHEVRON_RIGHT.svg": "4a59b",
	"./CHEVRON_TOP.svg": "2661",
	"./CLOCK.svg": "d827",
	"./CONNECTED.svg": "42e4",
	"./CREDIT_CARD.svg": "2a7c",
	"./DESC_SORT.svg": "7fa0",
	"./DISCONNECTED.svg": "094b",
	"./DOWNLOAD.svg": "d046",
	"./EDIT.svg": "6ffc",
	"./EQUAL.svg": "ffb4",
	"./EXPORT.svg": "8590",
	"./EYE.svg": "c972",
	"./FILTER.svg": "fb64",
	"./GTE.svg": "18dd",
	"./IMPORT.svg": "867f",
	"./INVOICE.svg": "6cd0",
	"./LIST.svg": "afb6",
	"./LTE.svg": "6ce35",
	"./MENU.svg": "cbe2",
	"./MIGRATION.svg": "c16c",
	"./MONEY.svg": "1184",
	"./MOVE.svg": "92d0",
	"./NOT_EQUAL.svg": "8272",
	"./PAY.svg": "f552",
	"./PHONE.svg": "8f63",
	"./PLUS.svg": "f23f",
	"./POST.svg": "f792",
	"./PRINT.svg": "718c",
	"./RECEIVE_MONEY.svg": "e097",
	"./REFRESH.svg": "9c3d",
	"./REFRESH_STATUS.svg": "3616",
	"./RETURN_SALE.svg": "6776",
	"./SALE.svg": "d829",
	"./SAVE.svg": "1f31",
	"./SAVE_CLOSE.svg": "27cb",
	"./SAVE_NEW.svg": "b856",
	"./SAVE_PAY.svg": "24de",
	"./SEARCH.svg": "e70b",
	"./SETTING.svg": "84ff",
	"./SUPPORT.svg": "7a9a",
	"./TIMES-CIRCLE.svg": "be3d",
	"./TIMES.svg": "8208",
	"./TRASH.svg": "64034",
	"./UPLOAD.svg": "75ff",
	"./USERAL.svg": "3381",
	"./WHATSAPP.svg": "0fe5",
	"./WOOCOMMERCE_LARGE.svg": "6fc7",
	"./WOOCOMMERCE_SMALL.svg": "6347",
	"./WOOCOMMERCE_TEXT.svg": "9d5c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";